// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__3SgbV","selects":"Documents_selects__ms2nZ"};